// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-tel-input {
  background-color: var(--sidebarTooltip) !important;
  border-radius: 0.625rem;
  height: 3rem;
  color: var(--white);
  box-shadow: none !important;
  border: 2px solid var(--headingLink);
}

.react-tel-input .form-control {
  height: 100%;
  width: 100%;
  background: var(--sidebarTooltip);
}

.react-tel-input .flag-dropdown {
  background-color: var(--sidebarTooltip);
}

.react-tel-input .flag-dropdown.open {
  z-index: 2;
  background: var(--sidebarTooltip);
  border-radius: 3px 0 0 0;
}

.react-tel-input .flag-dropdown.open .selected-flag {
  background: var(--sidebarTooltip);
}

.react-tel-input .selected-flag:hover,
.react-tel-input .selected-flag:focus {
  background-color: var(--sidebarTooltip);
}

.react-tel-input .selected-flag .arrow {
  border-top: 4px solid var(--lightkGray);
}

.react-tel-input .selected-flag .arrow.up {
  border-bottom: 4px solid var(--lightkGray);
}

.react-tel-input .country-list .country .dial-code {
  color: var(--lightkGray);
}

.react-tel-input .special-label {
  display: none;
}

.react-tel-input .country-list {
  background-color: var(--sidebarTooltip);
}

.react-tel-input .country-list .country:hover {
  background-color: var(--sidebarTooltip);
}

.react-tel-input .country-list .country.highlight {
  background-color: var(--sidebarTooltip);
}

.auth-form-wrap {
  padding: 15px;
}
.auth-form-wrap .auth-logo {
  text-align: center;
}
.auth-form-wrap .auth-logo img {
  width: 80%;
  margin: 0 auto;
}
.auth-form-wrap .auth-logo svg {
  width: 80%;
  margin: 0 auto;
}
.auth-form-wrap .auth-top-btn .nav {
  gap: 0.75rem;
}
.auth-form-wrap .auth-top-btn .nav .nav-item .nav-link {
  background-color: var(--authTabBtn);
  border: 2px solid transparent;
  border-radius: 0.625rem;
  color: var(--authTabBtnText);
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.75rem;
  padding: 0.375rem 1.625rem;
}
.auth-form-wrap .auth-top-btn .nav .nav-item .nav-link:hover {
  background-color: var(--headerBtnHover);
  border: 2px solid var(--headingLink);
  color: var(--headingLink);
}
.auth-form-wrap .auth-top-btn .nav .nav-item .nav-link.active, .auth-form-wrap .auth-top-btn .nav .nav-item .nav-link.active:hover {
  background-color: var(--authTabBtn);
  border: 2px solid var(--headingLink);
  color: var(--headingLink);
}
.auth-form-wrap .auth-btn-wrap {
  margin: 0.938rem 0;
}
.auth-form-wrap .auth-btn-wrap .btn {
  height: 50px;
}
.auth-form-wrap .auth-social-card {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.auth-form-wrap .auth-social-card a svg {
  width: 5rem;
}
@media screen and (max-width: 767.98px) {
  .auth-form-wrap .auth-social-card {
    width: 80px;
  }
  .auth-form-wrap .auth-social-card img {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Login/login.scss"],"names":[],"mappings":"AAsBA;EACE,kDAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;EACA,oCAAA;AArBF;;AAwBA;EACE,YAAA;EACA,WAAA;EACA,iCAAA;AArBF;;AAwBA;EACE,uCAAA;AArBF;;AAwBA;EACE,UAAA;EACA,iCAAA;EACA,wBAAA;AArBF;;AAwBA;EACE,iCAAA;AArBF;;AAwBA;;EAEE,uCAAA;AArBF;;AAwBA;EACE,uCAAA;AArBF;;AAwBA;EACE,0CAAA;AArBF;;AAwBA;EACE,wBAAA;AArBF;;AAyBA;EACE,aAAA;AAtBF;;AAyBA;EACE,uCAAA;AAtBF;;AAyBA;EACE,uCAAA;AAtBF;;AAyBA;EACE,uCAAA;AAtBF;;AAyBA;EACE,aAAA;AAtBF;AAwBE;EACE,kBAAA;AAtBJ;AAwBI;EACE,UAAA;EACA,cAAA;AAtBN;AAyBI;EACE,UAAA;EACA,cAAA;AAvBN;AA4BI;EACE,YAAA;AA1BN;AA6BQ;EACE,mCAAA;EACA,6BAAA;EACA,uBAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,0BAAA;AA3BV;AA6BU;EACE,uCAAA;EACA,oCAAA;EACA,yBAAA;AA3BZ;AA8BU;EAEE,mCAAA;EACA,oCAAA;EACA,yBAAA;AA7BZ;AAoCE;EACE,kBAAA;AAlCJ;AAoCI;EACE,YAAA;AAlCN;AAsCE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AApCJ;AAuCM;EACE,WAAA;AArCR;AAyCI;EAZF;IAaI,WAAA;EAtCJ;EAwCI;IACE,WAAA;EAtCN;AACF","sourcesContent":["// button.btn-close.btn-close-white {\n//   position: absolute;\n//   right: 30px;\n//   top: 25px;\n// }\n// #login_modal.modal .modal-content {\n//   background-color: var(--modalBG);\n// }\n\n// #login_modal .form-control {\n//   background-color: var(--darkBlue);\n//   border-radius: 60px;\n//   border: 1px solid transparent;\n//   padding: 15px 18px;\n//   color: #fff\n// }\n// #login_modal .form-control:focus {\n//   background-color: var(--darkBlue);\n//   box-shadow: none !important;\n//   color: var(--inputFocusText);\n// }\n\n.react-tel-input {\n  background-color: var(--sidebarTooltip) !important;\n  border-radius: 0.625rem;\n  height: 3rem;\n  color: var(--white);\n  box-shadow: none!important;\n  border:  2px solid var(--headingLink);\n}\n\n.react-tel-input .form-control {\n  height: 100%;\n  width: 100%;\n  background: var(--sidebarTooltip);\n}\n\n.react-tel-input .flag-dropdown {\n  background-color: var(--sidebarTooltip);\n}\n\n.react-tel-input .flag-dropdown.open {\n  z-index: 2;\n  background: var(--sidebarTooltip) ;\n  border-radius: 3px 0 0 0\n}\n\n.react-tel-input .flag-dropdown.open .selected-flag {\n  background:  var(--sidebarTooltip) ;\n}\n\n.react-tel-input .selected-flag:hover,\n.react-tel-input .selected-flag:focus {\n  background-color: var(--sidebarTooltip) ;\n}\n\n.react-tel-input .selected-flag .arrow {\n  border-top: 4px solid var(--lightkGray);\n}\n\n.react-tel-input .selected-flag .arrow.up {\n  border-bottom: 4px solid var(--lightkGray);\n}\n\n.react-tel-input .country-list .country .dial-code {\n  color: var(--lightkGray);\n}\n\n\n.react-tel-input .special-label {\n  display: none;\n}\n\n.react-tel-input .country-list {\n  background-color: var(--sidebarTooltip);\n}\n\n.react-tel-input .country-list .country:hover {\n  background-color: var(--sidebarTooltip);\n}\n\n.react-tel-input .country-list .country.highlight {\n  background-color: var(--sidebarTooltip);\n}\n\n.auth-form-wrap {\n  padding: 15px;\n\n  .auth-logo {\n    text-align: center;\n\n    img {\n      width: 80%;\n      margin: 0 auto;\n    }\n\n    svg {\n      width: 80%;\n      margin: 0 auto;\n    }\n  }\n\n  .auth-top-btn {\n    .nav {\n      gap: 0.75rem;\n\n      .nav-item {\n        .nav-link {\n          background-color: var(--authTabBtn);\n          border: 2px solid transparent;\n          border-radius: 0.625rem;\n          color: var(--authTabBtnText);\n          font-size: 0.875rem;\n          font-weight: 600;\n          line-height: 1.75rem;\n          padding: 0.375rem 1.625rem;\n\n          &:hover {\n            background-color: var(--headerBtnHover);\n            border: 2px solid var(--headingLink);\n            color: var(--headingLink);\n          }\n\n          &.active,\n          &.active:hover {\n            background-color: var(--authTabBtn);\n            border: 2px solid var(--headingLink);\n            color: var(--headingLink);\n          }\n        }\n      }\n    }\n  }\n\n  .auth-btn-wrap {\n    margin: 0.938rem 0;\n\n    .btn {\n      height: 50px;\n    }\n  }\n\n  .auth-social-card {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    a {\n      svg {\n        width: 5rem;\n      }\n    }\n\n    @media screen and (max-width: 767.98px) {\n      width: 80px;\n\n      & img {\n        width: 100%;\n      }\n    }\n  }\n\n  // .nav-link {\n  //   border-radius: 0.625rem;\n  //   background: var(--authTabBtn);\n  //   &.active{\n  //     border:2px solid var(--headingLink);\n  //     background: var(--authTabActiveBtnBg);\n  //   }\n  // }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
